import { axiosRequest } from '@/plugins/axios-common'

export const TeamActions = {
  getTeam: async (_, teamId) => {
    return axiosRequest.
      get(`/teams/${teamId}`).
      then(({ data }) => data)
  },

  getTeams: async ({ commit }) => {
    return axiosRequest.
      get('/teams').
      then(({ data }) => commit('setTeams', data))
  },
}
